import dayjs from 'dayjs';

import { i18n } from '@client/helper/i18n';
import LANG from '@root/config/dict/lang.json';

const { t } = i18n;

export function compareDate(str = 20200220, format = '') {
  const sameDay = dayjs(`${str}`).isSame(dayjs(), 'day');
  const weekDayBefore = dayjs().subtract(7, 'days');
  const weekDayAfter = dayjs().add(7, 'days');
  const weekDay = dayjs(`${str}`).isBetween(weekDayBefore, weekDayAfter, 'day', '()');
  if (sameDay) {
    return t('C1038');
  } else if (weekDay) {
    return dateIsWhatDayInWeek(str);
  } else if (format) {
    return dayjs(`${str}`).format(`${format}`);
  }
}

export function dateIsWhatDayInWeek(str = 20200220) {
  const num = Number(dayjs(`${str}`).format('d'));
  switch (num) {
    case 1:
      // 返回星期一
      return t('C1039');
    case 2:
      // 返回星期二
      return t('C1040');
    case 3:
      // 返回星期三
      return t('C1041');
    case 4:
      // 返回星期四
      return t('C1042');
    case 5:
      // 返回星期五
      return t('C1043');
    case 6:
      // 返回星期六
      return t('C1044');
    case 0:
      // 返回星期日
      return t('C1045');
  }
}

/**
 * 返回当前属于每周的第几天, 1-7, 1 星期一
 * @param {*} str
 * @returns
 */
export const dateIndexInWeek = (day) => {
  let index = 0;
  if (day > 0 && day < 7) {
    index = day - 1;
  } else if (day === 0) {
    index = 6;
  }
  return index;
};

// 转换为完整的时间字符串
export const s2hmsFullStr = (second = 0, splitStr = ':') => {
  second = parseInt(second);
  let ss = (second % 3600) % 60;
  let mm = Math.floor((second % 3600) / 60);
  let hh = Math.floor(second / 3600);

  ss = ss.toString().length === 1 ? `0${ss}` : ss;
  mm = mm.toString().length === 1 ? `0${mm}` : mm;
  hh = hh.toString().length === 1 ? `0${hh}` : hh;
  return `${hh}${splitStr}${mm}${splitStr}${ss}`;
};
//  将秒（s）转换成分秒（mm'ss"）
export const s2ms = (s = 0) => {
  const second = Math.round(parseFloat(s));
  const mm = Math.floor(second / 60);
  const ss = Math.floor(second % 60);
  return `${mm === 0 ? '00' : mm > 9 ? mm : '0' + mm}'${ss === 0 ? '00' : ss > 9 ? ss : '0' + ss}"`;
};

export function getShortLangId(locale) {
  return LANG.find((item) => item.code === locale).apiLangType;
}
// 从日期对象中获取时分秒加起来的总秒数
export function parseSeconds(str, format = 'mm:ss') {
  const targetDate = dayjs(str, format);
  const h = targetDate.hour();
  const m = targetDate.minute();
  const s = targetDate.second();
  return h * 3600 + m * 60 + s;
}
export const s2ClockStr = (second) => {
  const timeStr = s2hmsFullStr(second)
    .split(':')
    .map((item) => {
      return Number(item);
    });
  const h = timeStr[0] ? `${timeStr[0]}h` : '';
  const m = timeStr[1] ? `${timeStr[1]}m` : h ? '0m' : '';
  const s = timeStr[2] ? `${timeStr[2]}s` : m ? '0s' : '';
  const last = !h && !m && !s ? '0s' : '';
  // const last = !h && !m && !s ? '--' : ''
  return `${h}${m}${s}${last}`;
};
export const hhmmss2seconds = (timeVal) => {
  if (Array.isArray(timeVal)) {
    return timeVal.map((time) => hhmmss2seconds(time));
  }

  return timeVal
    .split(':')
    .reverse()
    .reduce((acc, val, i) => {
      return acc + Number(val) * Math.pow(60, i);
    }, 0);
};
// 获取相对于输入日期的上一个最近的周一日期对象, offsetWeeks 偏移周数[可选]
export const getLastMonday = (date, format = 'YYYY-MM-DD', offsetWeeks = 0) => {
  const day = dayjs(date, format);
  let weekday = day.day();
  if (!weekday) {
    // 周天
    weekday = 7;
  }
  const nextMonday = day
    .subtract(weekday - 1, 'day')
    .add(offsetWeeks, 'week')
    .format(format);
  return nextMonday;
};
// 根据传入的时间戳，获取所在月份的起始和结束日期对象
export const getMonthStartAndEnd = (timestamp, format = 'YYYY-MM-DD') => {
  const date = dayjs(timestamp, 'x');

  // 月份第一天
  const monthStartDay = dayjs(date.format('YYYY-MM'));
  // const startDate = monthStartDay.format(format);

  // 月份最后一天
  const monthEndDay = monthStartDay.add(1, 'month').subtract(1, 'day');

  return [monthStartDay, monthEndDay];
};
